import React from 'react';
import './HeroSection.css';

function HeroSection() {
    return (
        <div className="herosection">
            <div className="container">
                <div className="row">
                    <div className="col-md-7 hero_text">
                        <h1>
                            Discover <span>the Future of Recruitment and Onboarding with Our Game-Changing HR Solutions!</span>
                        </h1>
                        <p>Streamline the hiring process, from job posting to candidate selection and onboarding.</p>
                        <button id="contact">Contact Our Team</button>
                    </div>
                    <div className="col-md-5">
                        <div className="row">
                            <div className="col-md-6 circle-container">
                                <img src="/images/dhart/herosaas.jpg" alt="picture" />
                            </div>
                            {/* <div className="col-md-6 star">
                                <img src="/images/dhart/Star.jpg" alt="star" />
                            </div> */}
                        </div>
                        {/* <div className="row">
                            <div className="col-md-6 star">
                                <img src="/images/dhart/Star.jpg" alt="star" />
                            </div>
                            <div className="col-md-6 cylinder">
                                <img src="/images/dhart/cylinder.jpg" alt="cylinder" className="rotated-image" />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeroSection;
